import React, {useEffect} from "react";
import videojs from "video.js";
import videojsSeekButtons from "videojs-seek-buttons"
import "video.js/dist/video-js.css";
import "videojs-seek-buttons/dist/videojs-seek-buttons.css"

export const VideoJS = ( props ) => {

  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady } = props;

  React.useEffect(() => {
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      const player = playerRef.current = videojs(videoElement, options, () => {
        console.log("Activating seekbuttons plugin")
        player.seekButtons({
          forward: 10,
          back: 10
        })

        console.log("player is ready");
		playerRef.current.currentTime(0);
		console.debug("Current time: ["+playerRef.current.currentTime()+"]");
        onReady && onReady(player);
      });
    } else {
      // you can update player here [update player through props]
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options]);

  useEffect(()=>{
    if(videoRef.current) {
      videoRef.current.addEventListener('contextmenu',handleRightClick);
    }
  },[videoRef])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {

    return () => {
      if(videoRef.current) {
        videoRef.current.removeEventListener('contextmenu', handleRightClick);
      }
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  function handleRightClick(e){
    e.preventDefault();
  }
  return (
    <div data-vjs-player>
      <video preload="auto" ref={videoRef} className="video-js vjs-big-play-centered" id={'videoJS_container'}/>
    </div>
  );
}

export default VideoJS;
